<app-breadcrumb *ngIf="!this.note" [master]="'Struktura sieci'" [parentName]="'Notatki'" [name]="'Dodaj'"></app-breadcrumb>
<div class="note-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="noteForm">
  <div fxLayout="row" fxLayoutGap="15px">
    <button tabindex="-1" (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!noteForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon> <span> Zapisz</span>
    </button>
    <button *ngIf="!this.partnerObject && !this.ofwcaObject && !this.noteObject" (click)="save(true)"  [class.spinner]="processingRequest"
            [disabled]="!noteForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon> <span> Zapisz i dodaj kolejne</span>
    </button>
    <button tabindex="-1" (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start">
      <div fxFlex="50" fxLayout="column" fxLayoutGap="15px">

        <mat-card>
          <div fxFlex="100" fxLayout="column" fxLayoutGap="15px">
            <h3>Dane</h3>
            <app-dict style="width: 50%" dictType="type_of_meeting" label="Rodzaj"
                      [control]="typeOfMeetingControl"
                      [required]="true"></app-dict>
            <mat-error *ngIf="typeOfMeetingControl.hasError('backendError')">
            </mat-error>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="33">
                <app-datepicker
                  label="Data"
                  placeholder="2000-01-01 00:00"
                  [required]="true"
                  [control]="meetingDateControl"
                ></app-datepicker>
              </div>
              <div fxFlex="33">
                <div>
                  <ngx-timepicker-field
                    [format]="24"
                    [required]="true"
                    [defaultTime]="'12:00'"
                    [formControl]="meetingTimeControl">
                  </ngx-timepicker-field>
                </div>
              </div>
<!--              <div fxFlex="33">-->
<!--                <div>-->
<!--                  <app-datepicker-->
<!--                    label="Data do"-->
<!--                    placeholder="2000-01-01 00:00"-->
<!--                    [required]="false"-->
<!--                    [control]="meetingEndDateControl"-->
<!--                  ></app-datepicker>-->
<!--                </div>-->
<!--              </div>-->
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <mat-slide-toggle fxFlex="33" [disabled]="ofwcaSelect.value || partnerOutsideStructureSelect.value || this.partnerObject" [formControl]="partnerSelect" color="accent">Partner</mat-slide-toggle>
              <mat-slide-toggle fxFlex="33" [disabled]="partnerOutsideStructureSelect.value || partnerSelect.value && !partnerControl.value" [formControl]="ofwcaSelect" color="accent">OFWCA</mat-slide-toggle>
              <mat-slide-toggle [disabled]="partnerSelect.value || ofwcaSelect.value" [formControl]="partnerOutsideStructureSelect" color="accent">Partner poza strukturą</mat-slide-toggle>
            </div>

            <div *ngIf="partnerSelect.value" fxLayout="row" fxFlex.lt-md="100%">
              <app-dict-partners fxFlex="100" label="Partner" [control]="partnerControl"></app-dict-partners>
            </div>
            <div *ngIf="ofwcaSelect.value" fxLayout="row" fxFlex.lt-md="100%">
              <app-dict-ofwcas *ngIf="ofwcaSelect.value && !partnerSelect.value" fxFlex="100" label="OFWCA" [control]="ofwcaControl"></app-dict-ofwcas>
              <app-dict-ofwcas *ngIf="ofwcaSelect.value && partnerControl.value && partnerOfwcas.length"
                               fxFlex="100"
                               [multiple]="true"
                               label="OFWCA"
                               [status]="true"
                               [ofwcaItems]="partnerOfwcas"
                               [control]="ofwcasControl"
                               [minimalDisplay]="true"
              ></app-dict-ofwcas>
            </div>

            <app-partner-facility-select
              *ngIf="(ofwcaControl.value || partnerControl.value) && !verificationSalesProcessControl.value"
              [control]="facilityControl"
              [partnerIdString]="partnerControl.value"
              [ofwcaIdString]="ofwcaControl.value"
              fxFlex="100"
              label="Placówka"
              [returnKey]="false">
            </app-partner-facility-select>

            <div *ngIf="partnerOutsideStructureSelect.value" fxLayout="row" fxFlex.lt-md="100%">
              <mat-form-field fxFlex="100">
                <mat-label>Wprowadź dane partnera</mat-label>
                <input type="text" matInput [formControl]="partnerOutsideStructureControl">
              </mat-form-field>
            </div>
            <mat-slide-toggle *ngIf="noteObject" [formControl]="tookPlaceControl" color="accent">Spotkanie odwołane</mat-slide-toggle>
          </div>
        </mat-card>
        <mat-card class="note-grid-item">
          <mat-form-field fxFlex="100">
            <mat-label>Dodaj notatkę</mat-label>
            <textarea formControlName="noteData" matInput placeholder="Dodaj notatkę..." rows="6" maxlength="200" style="resize: none;"></textarea>
            <mat-hint align="end">{{noteData.value?.length || 0}}/200</mat-hint>
          </mat-form-field>
        </mat-card>
      </div>

      <div fxFlex="50" fxLayout="column" fxLayoutGap="15px">
        <mat-card class="checkboxy">
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxLayout="column" fxLayoutGap="15px" fxLayoutAlign="start" style="width: 100%;">
              <mat-slide-toggle [disabled]="!partnerControl.value" [formControl]="verificationSalesProcessControl" color="accent">
                Weryfikacja procesu sprzedaży
              </mat-slide-toggle>
              <mat-slide-toggle [formControl]="resultsControl" color="accent">Wyniki</mat-slide-toggle>
              <mat-slide-toggle [formControl]="trainingControl" color="accent">Szkolenia</mat-slide-toggle>
              <mat-slide-toggle [formControl]="relationsControl" color="accent">Relacje</mat-slide-toggle>
              <mat-slide-toggle [formControl]="controlControl" color="accent">Kontrola</mat-slide-toggle>
              <mat-slide-toggle [formControl]="recruitmentControl" color="accent">Rekrutacja</mat-slide-toggle>
              <mat-slide-toggle [formControl]="otherControl" color="accent">Inne</mat-slide-toggle>
            </div>
            <mat-form-field *ngIf="otherControl.value" fxFlex="100" class="limited-height">
              <mat-label>Inne</mat-label>
              <textarea [formControl]="other" matInput placeholder="Inne" maxlength="100" rows="3" style="resize: none;"></textarea>
              <mat-hint align="end">{{other.value?.length || 0}}/100</mat-hint>
            </mat-form-field>
          </div>
        </mat-card>
        <mat-card *ngIf="verificationSalesProcessControl.value && partnerSelect.value && !noteObject?.verificationSales">
          <div fxLayout="column" fxLayoutGap="15px">
            <mat-label>Weryfikacja procesu sprzedaży</mat-label>

            <app-partner-facility-select
              [control]="facilityControl"
              [partnerIdString]="partnerControl.value"
              fxFlex="100"
              label="Placówka"
              [returnKey]="true"
            ></app-partner-facility-select>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="facilityControl.value">
              <button [disabled]="processingVerificationRequest" *ngIf="!partnerFacilityVerificationSalesProcessObject" fxFlex="100" (click)="addVerificationSalesProcess()" [class.spinner]="processingVerificationRequest" mat-stroked-button color="primary">
                <span>Dodaj formularz</span>
              </button>
              <button *ngIf="partnerFacilityVerificationSalesProcessObject" fxFlex="33" mat-raised-button [ngClass]="partnerFacilityVerificationSalesProcessObject?.status?.color + '-button'">{{partnerFacilityVerificationSalesProcessObject?.status?.name}}</button>
              <button *ngIf="partnerFacilityVerificationSalesProcessObject" fxFlex="33" matTooltip="Generuj plik pdf" (click)="downloadCertificates(facilityControl.value.address.uuid)" mat-stroked-button color="accent"><mat-icon>picture_as_pdf</mat-icon></button>
              <button *ngIf="partnerFacilityVerificationSalesProcessObject" fxFlex="33" matTooltip="Dodaj skan" (click)="addDocument()" mat-stroked-button color="accent"><mat-icon>post_add</mat-icon></button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="buttons" fxLayout="row" fxLayoutGap="15px">
      <button (click)="save()" [class.spinner]="processingRequest"
              [disabled]="!noteForm.valid || processingRequest"
              mat-stroked-button color="primary">
        <mat-icon>save</mat-icon> <span> Zapisz</span>
      </button>
      <button *ngIf="!this.partnerObject && !this.ofwcaObject && !this.noteObject" (click)="save(true)"  [class.spinner]="processingRequest"
              [disabled]="!noteForm.valid || processingRequest"
              mat-stroked-button color="primary">
        <mat-icon>save</mat-icon> <span> Zapisz i dodaj kolejne</span>
      </button>
      <button (click)="cancel()" mat-stroked-button color="warn">
        <mat-icon>cancel</mat-icon> <span> Anuluj</span>
      </button>
  </div>

</div>
